import { useMutation, useQuery, UseQueryResult } from 'react-query';
import QUERY_KEYS from '../Utils/Const/queries-keys';
import DeliveryAPI from '../Api/booking';
import { QueryOptions } from './types/query';
import { Booking } from './types/booking';
import TypedBookingsAPI from '../Api/bookings';

export type BookingData = {
  bookings: Booking[];
  count: number;
};

export const useSearchBookingByReference = (
  reference: string,
  options: QueryOptions<BookingData> = {},
): UseQueryResult<BookingData> =>
  useQuery<BookingData>(
    [QUERY_KEYS.SEARCH_BOOKING, reference],
    () => DeliveryAPI.findBookings(reference),
    {
      enabled: !!reference,
      ...options,
    },
  );

export const useCheckInDelivery = () =>
  useMutation(
    async ({
      deliveryId,
      deliveredAt,
    }: {
      deliveryId: string;
      deliveredAt: Date;
    }) => TypedBookingsAPI.checkInDelivery(deliveryId, deliveredAt),
    {
      onError: (error) => {
        console.error('Error while checking in delivery', error);
      },
    },
  );
